module.exports = __webpack_public_path__ + "static/media/hankin_jon_hankin.760646b0.jpg";